import multiavatar from '@multiavatar/multiavatar/esm';

export type AvatarKind = 'human' | 'group' | 'ai';

export function avatarSeed(id: number | string, kind: AvatarKind = 'human') {
  return `${kind}:${String(id).trim() || 'unknown'}`;
}

export function multiavatarSvg(id: number | string, kind: AvatarKind = 'human') {
  return multiavatar(avatarSeed(id, kind));
}

export function multiavatarDataUrl(id: number | string, kind: AvatarKind = 'human') {
  return `data:image/svg+xml;utf8,${encodeURIComponent(multiavatarSvg(id, kind))}`;
}
